// import { Link, Outlet, useLocation } from "react-router-dom"
import logo from '../assets/logo.png';

export const Home = () => {
    return <div className="App">
        <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
        </header>
    </div>
}